


















































































































import {getDicts} from '@/api/system/dict/data';
import {
  addUser,
  changeUserStatus,
  clearCache,
  delUser,
  getUser,
  listUser,
  resetSecretKey,
  updateUser
} from '@/api/system/third/user';
import {selectDictLabel} from '@/utils/ruoyi';
import {msgSuccess} from '@/plugins/element';
import {ElForm} from 'element-ui/types/form';
import Vue from 'vue';

export default Vue.extend({
  name: 'Third',
  data() {
    return {
      // 遮罩层
      loading: true,
      // 选中数组
      appIds: [],
      names: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 第三方用户表格数据
      userList: [],
      // 弹出层标题
      title: '',
      // 是否显示弹出层
      open: false,
      // 弹出层标题
      secretKeyTitle: '',
      // 是否显示弹出层
      secretKeyOpen: false,
      // 状态数据字典
      statusOptions: [],
      // 查询参数
      queryParams: {
        pageIndex: 1,
        pageSize: 10,
        name: undefined,
        appId: undefined,
        status: undefined
      },
      // 表单参数
      form: {} as any,
      secretKeyForm: {
        rsaPublicKey: undefined,
        rsaPrivateKey: undefined,
        aesKey: undefined,
      } as any,
      // 表单校验
      rules: {
        name: [
          {required: true, message: '调用方名称不能为空', trigger: 'blur'}
        ]
      }
    };
  },
  created() {
    this.getList();
    getDicts('sys_normal_disable').then(response => {
      this.statusOptions = response.data;
    });
  },
  methods: {
    getList() {
      this.loading = true;
      listUser(this.queryParams).then(response => {
          this.userList = response.data.list;
          this.total = response.data.total;
          this.loading = false;
        }
      );
    },

    statusFormat(row) {
      return selectDictLabel(this.statusOptions, row.status);
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 表单重置
    reset() {
      this.form = {
        appId: undefined,
        name: undefined,
        status: '0',
        remark: undefined
      };
      this.resetForm('form');
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageIndex = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm('queryForm');
      this.handleQuery();
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset();
      this.open = true;
      this.title = '添加调用方';
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.appIds = selection.map(item => item.appId);
      this.names = selection.map(item => item.name);
      this.single = selection.length != 1;
      this.multiple = !selection.length;
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      this.reset();
      const appId = row.appId || this.appIds;
      getUser(appId).then(response => {
        this.form = response.data;
        this.open = true;
        this.title = '修改调用方信息';
      });
    },
    /** 提交按钮 */
    submitForm: function () {
      (this.$refs['form'] as ElForm).validate(valid => {
        if (valid) {
          if (this.form.appId != undefined) {
            updateUser(this.form).then(() => {
              msgSuccess('修改成功');
              this.open = false;
              this.getList();
            });
          } else {
            addUser(this.form).then(() => {
              msgSuccess('新增成功');
              this.open = false;
              this.getList();
            });
          }
        }
      });
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      const appIds = row.appId || this.appIds;
      const names = row.name || this.names;
      this.$confirm('是否确认删除调用方名称【' + names + '】的数据项?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        return delUser(appIds);
      }).then(() => {
        this.getList();
        msgSuccess('删除成功');
      });
    },
    /** 清理缓存按钮操作 */
    handleClearCache() {
      clearCache().then(() => {
        msgSuccess('清理成功');
      });
    },
    // 用户状态修改
    handleStatusChange(row) {
      let text = row.status === '0' ? '启用' : '停用';
      this.$confirm('确认要【' + text + '】接口调用方【' + row.name + '】吗?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        return changeUserStatus(row.appId, row.status);
      }).then(() => {
        msgSuccess(text + '成功');
      }).catch(function () {
        row.status = row.status === '0' ? '1' : '0';
      });
    },
    /** 修改按钮操作 */
    handleQuerySecretKey(row) {
      const appId = row.appId || this.appIds;
      getUser(appId).then(response => {
        this.secretKeyForm = response.data;
        this.secretKeyOpen = true;
        this.secretKeyTitle = '查看密钥';
      });
    },
    handleResetSecretKey(row) {
      const appId = row.appId || this.appIds;
      this.$confirm('确认重置接口调用方【' + row.name + '】的密钥吗?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        return resetSecretKey(appId);
      }).then(() => {
        this.getList();
        msgSuccess('重置成功');
      });
    },
    // 取消按钮
    cancelSecretKeyDialog() {
      this.secretKeyOpen = false;
    },
  }
});
